import { Component, EventEmitter, Input, OnInit, Output, ChangeDetectionStrategy } from '@angular/core';
import { CommonModule } from '@angular/common'; // Import CommonModule
import { ReactiveFormsModule } from '@angular/forms';
import { BlockTextComponent } from '../../../common/block-text/block-text.component';
import {
  ValamarAppInitModel,
  ValamarAppInitVariables,
  ValamarAppModel,
  ValamarAppVariables,
} from '../../../../../models/email-template/valamar-app.interface';
import { BaseComponent } from '../../../common/BaseComponent';
import { NotificationComponent } from '../../../common/notification/notification.component';
import { PinComponent } from '../../../common/pin/pin.component';
import { Helper } from '../../../../../utils/helper';

@Component({
    selector: 'app-valamar-app',
    imports: [
        CommonModule,
        ReactiveFormsModule,
        BlockTextComponent,
        NotificationComponent,
        PinComponent,
    ],
    templateUrl: './valamar-app.component.html',
    changeDetection: ChangeDetectionStrategy.Eager,
    styleUrl: './valamar-app.component.scss'
})
export class ValamarAppComponent extends BaseComponent implements OnInit {
  @Input() block: ValamarAppModel = new ValamarAppInitModel();
  @Input() isPreview = false;
  @Output() blockData = new EventEmitter<any>();
  @Output() removeBlockEvent = new EventEmitter<string | null>();

  ngOnInit() {
    if (Helper.isEmpty(this.block.variables!)) {
      this.block.variables = new ValamarAppInitVariables()
    }
  }

  //placeholders:
  headingPlaceholder: string = 'Enter Heading Text';
  textPlaceholder: string = 'Enter Text';
  imagePlaceholder: string = 'Image';
  hrefPlaceholder: string = 'Enter Image Redirect Link';
  altPlaceholder: string = 'Enter Image Alt';
  ctaLink1Placeholder: string = 'Enter First CTA Link';
  ctaLink2Placeholder: string = 'Enter Second CTA Link';

  removeBlock(): void {
    this.removeBlockEvent.emit(this.block.blockId); // Emit the ID to parent
  }

  onChange(value: any, fieldName: keyof ValamarAppVariables) {
    if (this.block.variables) {
      this.block.variables[fieldName] = value;
      this.blockData.emit(this.block);
    }
  }

  onContainerClick(event: MouseEvent) {
    // Forward the click event to the child app-pin component
    this.pinComponent.onContainerClick(event);
  }

  handleOnSegmentChange(segment: string, blockName: string) {
    if (this.block.variables) {
      this.block.variables[blockName as keyof ValamarAppVariables] = segment;
      this.blockData.emit(this.block);
    }
    return;
  }
}
